import {
  ChatBubble,
  ChatMeta,
} from '@eriko/ui/src/components/ui/chat';
import { useEffect } from 'react';
import { getPublicProfile } from '../../../api/users';
import type { ChatMessage } from '../../../stores/chatStore';
import { useChatStore } from '../../../stores/chatStore';

function useReviewerProfile(userId: string | null | undefined) {
  const profile = useChatStore((s) => (userId ? s.reviewerProfiles[userId] : undefined));
  const setProfile = useChatStore((s) => s.setReviewerProfile);
  useEffect(() => {
    if (!userId || profile) return;
    getPublicProfile(userId)
      .then(setProfile)
      .catch(() => {
        /* non-fatal */
      });
  }, [userId, profile, setProfile]);
  return profile;
}

interface ReviewerMessageProps {
  msg: ChatMessage;
}

export function ReviewerMessage({ msg }: ReviewerMessageProps) {
  const profile = useReviewerProfile(msg.senderId);
  const name = profile?.fullName || 'Your bookkeeper';
  const initials = profile?.initials || 'BK';

  return (
    <div className="flex gap-3 animate-[fade-up_0.25s_ease-out]">
      <div className="mt-6 w-8 h-8 rounded-full flex items-center justify-center shrink-0 bg-pos-surface text-pos border border-pos-border text-[11px] font-bold">
        {initials}
      </div>
      <div className="max-w-[78%]">
        <ChatMeta name={name} tag="Bookkeeper" tagVariant="human" time={msg.timestamp} />
        <ChatBubble variant="assistant" >
          <div className="text-sm leading-relaxed text-surface-900 whitespace-pre-wrap">
            {msg.content}
          </div>
        </ChatBubble>
      </div>
    </div>
  );
}
